import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ExtensionsService } from '../_services/extensions.service';
import { VOIPService } from '../_services/voip.service';
import { ContractProcessorsService } from '../../companies/_services/contracts-processors.service';
import { UsersService } from '../../users/_services/users.service';
import { User } from '../../users/_types/user';
import { ContractProcessor } from '../../companies/_types/contract-processor';
import { ContractsService } from '../../companies/_services/contracts.service';
import { Contract } from '../../companies/_types/contract';
import { QueuesService } from '../_services/queues.service';
import { Queue } from '../_types/queue';
import { QueuesMembersService } from '../_services/queues-members.service';
import { QueueMember } from '../_types/queue-member';

@Component({
    selector: 'app-voip-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.css'],
    standalone: false
})
export class VOIPStatusComponent implements OnInit {
  public users: any[] = [];
  public queues: Queue[] = [];
  public queuesMembers: any[] = [];
  public extensions: any = [];
  public endpointStatus: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private loadStatusTimeout: any;

  constructor(
    public topbarService: TopbarService,
    public extensionsService: ExtensionsService,
    public queuesService: QueuesService,
    public usersService:UsersService,
    public contractsService:ContractsService,
    public contractProcessorsService:ContractProcessorsService,
    private voipService: VOIPService,
    private queueMembersService: QueuesMembersService
  ) {
  }

  async ngOnInit() {
    this.topbarService.setTitle("Estado de centralita");
    this.loadQueues();
    this.loadQueuesMembers();
    //this.loadContractProcessors();
  }

  ngOnDestroy() {
    if (this.loadStatusTimeout) {
      clearTimeout(this.loadStatusTimeout);
    }
  }

  async loadUsers(){
    //cargamos solo los usuarios que están activos.
    this.users = await firstValueFrom(this.usersService.all({ page: { number: 1, size: 1000 } })).then(response => response.data);
    
    //asignamos el nombre de usuario
    var aux: any[] = [];

    this.queuesMembers.forEach((member: any) => {
      let user = this.users.find(u => 'PJSIP/' + u.userName == member.interface);
      member.name = user ? user.name : '('+member.interface+')';
      member.sipExtension = user ? user.sipExtension : '(sin extension)';
      //se mete o si no existe el usuario o si existe y está activo
      if(!user) aux.push(member);
      if(user && user.active) aux.push(member);
    });
    this.queuesMembers = aux;
    this.loadStatus();
  }

  /*async loadContracts(){
    this.contracts = await firstValueFrom(this.contractsService.all({ page: { number: 1, size: 1000 }, sort: ['name'] })).then(response => response.data);
  }*/

  async loadQueues(){
    this.queues = await firstValueFrom(this.queuesService.all({ page: { number: 1, size: 1000 }, sort: ['name'] })).then(response => response.data);
  }

  async loadQueuesMembers(){
    this.queuesMembers = await firstValueFrom(this.queueMembersService.all({ page: { number: 1, size: 1000 }, sort: ['membername'] })).then(response => response.data);
    this.loadUsers();
  }

  /*async loadContractProcessors(){
    this.contractProcessors = await firstValueFrom(this.contractProcessorsService.all({ page: { number: 1, size: 1000 } })).then(response => response.data);
  }*/

  async loadStatus(){
    let response = await firstValueFrom(this.voipService.pjsipShowEndpoints());
    this.endpointStatus = response;
    this.queuesMembers.forEach((member: any) => {
      let endpoint = this.endpointStatus.find(  (item: any) => ('PJSIP/' + item.name).toUpperCase() === member.interface.toUpperCase());
      let status = endpoint?.status || 'unknown';

      console.log(member.interface, status, endpoint);

      if(!endpoint) status = 'unavailable';
      let state = this.voipService.getEndpointsStates().find((item: any) => item.value === status);
      member.status = state?.label || 'Desconocido';
      member.severity = state?.severity || 'info';
      member.rtl = endpoint?.rtl;
    });
    this.loadStatusTimeout = setTimeout(() => {
      this.loadStatus();
    }, 30 * 1000);
  }

  /*getContractProcessors(queue: Queue): any[] {
    let contract = this.contracts.find(c => c.name == queue.name);
    if(!contract){
      console.warn(`No se ha encontrado ningún contrato con nombre ${queue.name} para la cola ${queue.id}`);
      return [];
    }else{
      let userIds = this.contractProcessors.filter(cp => cp.contractId === contract?.id).map(cp => ({ processorId: cp.processorId }));
      return this.users.filter(user => userIds.some(cp => cp.processorId === user.id));
    }
  }*/

  getQueueMembers(queue: Queue): any[] {
    return this.queuesMembers.filter(qm => qm.queueName == queue.name);
  }

}
